import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import { OutlinedInput } from "@mui/material";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "dayjs/locale/es";
import Select from "@mui/material/Select";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import DeleteIcon from "@mui/icons-material/Delete";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Backdrop from "@mui/material/Backdrop";
import Restricted from "components/Restricted";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import { IMaskInput } from "react-imask";
import clienteAxios from "../../config/clienteAxios";
import axios from "axios";
import FormHelperText from "@mui/material/FormHelperText";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{
        p: 1,
        m: 1,
        fontSize: "0.875rem",
        fontWeight: "700",
        ...sx,
      }}
      {...other}
    />
  );
}

Item.propTypes = {
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="+00(#00) 000-0000"
      definitions={{
        "#": /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const options = {
  smooth: true,
};

const SaludForm = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("prop");
  const proyect = JSON.parse(token);
  let tipoActividad = 0;
  const tipoAct = proyect.actividad;

  // Definimos los valores en un objeto para mayor claridad
  const valoresActividad = {
    "Jornada de Nutrición": 1,
    "Control Nutricional": 1,
    "Jornada Médica": 2,
    "Telemedicina": 3,
  };
  const [clasificacion, setClasificacion] = React.useState("");
  // Verificamos el caso especial primero
  if (tipoAct.includes("Telemedicina") && tipoAct.includes("Jornada Médica")) {
    tipoActividad = 3;
    setClasificacion("Telemedicina");
  } else {
    // Si no es el caso especial, sumamos los valores usando el mapa
    for (const actividad of tipoAct) {
      // Suma el valor correspondiente del objeto. Si no lo encuentra, suma 0.
      tipoActividad += valoresActividad[actividad] || 0;
    }
  }

  console.log("El valor final de tipoActividad es:", tipoActividad);

  const nav = useNavigate();

  const [items, setItems] = React.useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  //Theme
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");

  const [errors, setErrors] = useState({});
  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  //DatePicker Value
  const [fechaNacSalud, setFechaNacSalud] = React.useState(null);
  const [valueResp, setValueResp] = React.useState(null);
  const [fechaActSalud, setFechaActSalud] = React.useState(proyect.fecha);

  //Modal Handlers
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //Motivo de Consulta Input
  const [data, setData] = useState([{ motivoConsulta: "" }]);
  const [activar, setActivar] = useState(true);
  const [actDelete, setActDelete] = useState(true);
  let contador = 0;
  let contadorDelete = 0;

  const handleClick = () => {
    setData([...data, { motivoConsulta: "" }]);
    setActivar(true);
    setActDelete(true);
  };
  const handleChangeInput = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...data];
    onchangeVal[i][name] = value;
    setData(onchangeVal);
    clearError("motivoConsulta");
    let hasEmptyField = false;
    for (let j = 0; j < onchangeVal.length; j++) {
      if (onchangeVal[j].motivoConsulta.trim() === "") {
        hasEmptyField = true;
        break;
      }
    }
    setActivar(hasEmptyField);
  };
  const handleDelete = (i) => {
    const deleteVal = [...data];
    deleteVal.splice(i, 1);
    setData(deleteVal);
  };

  //Diagnostico Inputs
  const [data3, setData3] = useState([{ diagnostico: "" }]);
  const [activar3, setActivar3] = useState(true);
  let contador3 = 0;

  const handleClick3 = () => {
    setData3([...data3, { diagnostico: "" }]);
    setActivar3(true);
  };
  const handleChangeInput3 = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal3 = [...data3];
    onchangeVal3[i][name] = value;
    setData3(onchangeVal3);
    clearError("diagnostico");
    let hasEmptyField = false;
    for (let j = 0; j < onchangeVal3.length; j++) {
      if (onchangeVal3[j].diagnostico.trim() === "") {
        hasEmptyField = true;
        break;
      }
    }
    setActivar3(hasEmptyField);
  };
  const handleDelete3 = (i) => {
    const deleteVal3 = [...data3];
    deleteVal3.splice(i, 1);
    setData3(deleteVal3);
  };

  // Tipo de Enfermedad Inputs
  const [data4, setData4] = useState([{ tipoEnfermedad: "" }]);
  const [activar4, setActivar4] = useState(true);
  let contador4 = 0;

  const handleClick4 = () => {
    setData4([...data4, { tipoEnfermedad: "" }]);
    setActivar4(true);
  };
  const handleChangeInput4 = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal4 = [...data4];
    onchangeVal4[i][name] = value;
    setData4(onchangeVal4);
    for (let i = 0; i < data4.length; i++) {
      if (data4[i].tipoEnfermedad !== "") {
      } else {
        contador4 = contador4 + 1;
      }
      if (contador4 !== 0) {
        setActivar4(true);
      } else {
        setActivar4(false);
      }
    }
  };
  const handleDelete4 = (i) => {
    const deleteVal4 = [...data4];
    deleteVal4.splice(i, 1);
    setData4(deleteVal4);
  };

  //Routes
  const handleLinkCancelar = (event, message) => {
    if (message === "cancelar") {
      nav("/transcripcion");
    }
  };

  const handleLinkHome = (event, message) => {
    if (message === "home") {
      nav("/inicio");
    }
  };

  const handleLinkTranscripcion = (event, message) => {
    if (message === "transcripcion") {
      nav(-1);
    }
  };

  //Modal Styles
  const style = {
    position: "inherit",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 375,
    bgcolor: theme.palette.background.alt,
    border: "2px solid #000",
    borderRadius: 4,
    boxShadow: 1,
    p: 4,
  };

  //Inputs States
  const [estadoSalud, setEstadoSalud] = useState(proyect.estadoConvo);
  const [municipioSalud, setMunicipioSalud] = useState(proyect.municipio);
  const [parroquiaSalud, setParroquiaSalud] = useState(proyect.parroquia);
  const [comunidadSalud, setComunidadSalud] = useState("");
  const [estSalud, setEstSalud] = useState(proyect.comunidad);
  const [valueCedula, setValueCedula] = useState("");
  const [tlf, setValueTlf] = useState({ textmask: "" });
  const handleTlf = (event) => {
    setValueTlf({
      ...tlf,
      [event.target.name]: event.target.value,
    });
  };
  const [peso, setPeso] = useState("");
  const [valueRep, setValueRep] = useState("");
  const [valueApellidoRep, setValueApellidoRep] = useState("");
  const [valueNombre, setValueNombre] = useState("");
  const [codigoBeneficiario, setCodigoBeneficiario] = useState("");
  const [valueApellido, setValueApellido] = useState("");
  const [valueComunidad, setValueComunidad] = useState("");
  const [edadSalud, setEdadSalud] = useState("");
  const [rangoEdadSalud, setRangoEdadSalud] = useState("");
  const [valueTipoDisc, setValueTipoDisc] = useState("");
  const [valueDiagnostico1, setValueDiagnostico1] = useState("");
  const [valueDiagnostico2, setValueDiagnostico2] = useState("");
  const [valueDiagnostico3, setValueDiagnostico3] = useState("");
  const [tipoEnfermedad, setTipoEnfermedad] = useState("");
  const [tipoEnfermedad2, setTipoEnfermedad2] = useState("");
  const [valueMedico, setValueMedico] = useState("");
  const [comentAdicionales, setValueCA] = useState("");

  const [codigoGrupoEtnico, setCodigoGrupoEtnico] = useState("");
  const handleCodigoGrupoEtnico = (event) => {
    const inputValue = event.target.value;
    clearError("codigoGrupoEtnico");
    if (inputValue === "") {
      setCodigoGrupoEtnico("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 7) {
      setCodigoGrupoEtnico(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 7)) {
      setCodigoGrupoEtnico("");
    } else {
      setCodigoGrupoEtnico(inputValue);
    }
  };

  const [grupoEtnico, setGrupoEtnico] = React.useState("");
  useEffect(() => {
    if (codigoGrupoEtnico === "") {
      setGrupoEtnico("");
    } else if (codigoGrupoEtnico >= 1 && codigoGrupoEtnico <= 7) {
      const map = {
        1: "Mestizo",
        2: "Wayuu",
        3: "Añu",
        4: "Japreria",
        5: "Yanomami",
        6: "Bari",
        7: "Yukpa",
      };
      setGrupoEtnico(map[codigoGrupoEtnico]);
    } else {
      setGrupoEtnico("VERIFICAR CÓDIGO");
    }
  }, [codigoGrupoEtnico]);

  const [codigoDisc, setCodigoDisc] = useState("");
  const handleCodigoDisc = (event) => {
    const inputValue = event.target.value;
    clearError("codigoDisc");
    if (inputValue === "") {
      setCodigoDisc("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 5) {
      setCodigoDisc(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 5)) {
      setCodigoDisc("");
    } else {
      setCodigoDisc(inputValue);
    }
  };

  const [valueDisc, setDisc] = React.useState("");
  useEffect(() => {
    if (codigoDisc === "") {
      setDisc("");
    } else if (codigoDisc >= 1 && codigoDisc <= 5) {
      const map = {
        1: "Física",
        2: "Intelectual",
        3: "Sensorial",
        4: "Múltiple",
        5: "Ninguna",
      };
      setDisc(map[codigoDisc]);
    } else {
      setDisc("VERIFICAR CÓDIGO");
    }
  }, [codigoDisc]);

  const [codigoMovilidad, setCodigoMovilidad] = useState("");
  const handleCodigoMovilidad = (event) => {
    const inputValue = event.target.value;
    clearError("codigoMovilidad");
    if (inputValue === "") {
      setCodigoMovilidad("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 5) {
      setCodigoMovilidad(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 5)) {
      setCodigoMovilidad("");
    } else {
      setCodigoMovilidad(inputValue);
    }
  };

  const [condicionMovilidad, setCondicionMovilidad] = React.useState("");
  useEffect(() => {
    if (codigoMovilidad === "") {
      setCondicionMovilidad("");
    } else if (codigoMovilidad >= 1 && codigoMovilidad <= 5) {
      const map = {
        1: "Local",
        2: "Desplazado Interno",
        3: "Refugiado",
        4: "Retornado",
        5: "Pendular",
      };
      setCondicionMovilidad(map[codigoMovilidad]);
    } else {
      setCondicionMovilidad("VERIFICAR CÓDIGO");
    }
  }, [codigoMovilidad]);

  const [codigoFactoresRiesgo, setCodigoFactoresRiesgo] = useState("");
  const handleCodigoFactoresRiesgo = (event) => {
    const inputValue = event.target.value;
    clearError("codigoFactoresRiesgo");
    if (inputValue === "") {
      setCodigoFactoresRiesgo("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 12) {
      setCodigoFactoresRiesgo(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 12)) {
      setCodigoFactoresRiesgo("");
    } else {
      setCodigoFactoresRiesgo(inputValue);
    }
  };

  const [factoresRiesgo, setFactoresRiesgo] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    if (map[codigoFactoresRiesgo]) {
      setFactoresRiesgo(map[codigoFactoresRiesgo]);
    } else if (codigoFactoresRiesgo) {
      setFactoresRiesgo("VERIFICAR CÓDIGO");
    } else {
      setFactoresRiesgo("");
    }
  }, [codigoFactoresRiesgo]);

  const [codigoFactoresRiesgo2, setCodigoFactoresRiesgo2] = useState("");
  const handleCodigoFactoresRiesgo2 = (event) => {
    const inputValue = event.target.value;
    clearError("codigoFactoresRiesgo2");
    if (inputValue === "") {
      setCodigoFactoresRiesgo2("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 12) {
      setCodigoFactoresRiesgo2(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 12)) {
      setCodigoFactoresRiesgo2("");
    } else {
      setCodigoFactoresRiesgo2(inputValue);
    }
  };

  const [factoresRiesgo2, setFactoresRiesgo2] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    if (map[codigoFactoresRiesgo2]) {
      setFactoresRiesgo2(map[codigoFactoresRiesgo2]);
    } else if (codigoFactoresRiesgo2) {
      setFactoresRiesgo2("VERIFICAR CÓDIGO");
    } else {
      setFactoresRiesgo2("");
    }
  }, [codigoFactoresRiesgo2]);

  const [codigoFactoresRiesgo3, setCodigoFactoresRiesgo3] = useState("");
  const handleCodigoFactoresRiesgo3 = (event) => {
    const inputValue = event.target.value;
    clearError("codigoFactoresRiesgo3");
    if (inputValue === "") {
      setCodigoFactoresRiesgo3("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 12) {
      setCodigoFactoresRiesgo3(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 12)) {
      setCodigoFactoresRiesgo3("");
    } else {
      setCodigoFactoresRiesgo3(inputValue);
    }
  };

  const [factoresRiesgo3, setFactoresRiesgo3] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    if (map[codigoFactoresRiesgo3]) {
      setFactoresRiesgo3(map[codigoFactoresRiesgo3]);
    } else if (codigoFactoresRiesgo3) {
      setFactoresRiesgo3("VERIFICAR CÓDIGO");
    } else {
      setFactoresRiesgo3("");
    }
  }, [codigoFactoresRiesgo3]);

  const [codigoNivelEducativo, setCodigoNivelEducativo] = useState("");
  const handleCodigoNivelEducativo = (event) => {
    const inputValue = event.target.value;
    clearError("codigoNivelEducativo");
    if (inputValue === "") {
      setCodigoNivelEducativo("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 6) {
      setCodigoNivelEducativo(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 6)) {
      setCodigoNivelEducativo("");
    } else {
      setCodigoNivelEducativo(inputValue);
    }
  };

  const [nivelEducativo, setNivelEducativo] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Prescolar",
      2: "Primaria",
      3: "Secundaria",
      4: "Universitario",
      5: "Sin estudios",
      6: "Analfabeta",
    };
    if (map[codigoNivelEducativo]) {
      setNivelEducativo(map[codigoNivelEducativo]);
    } else if (codigoNivelEducativo) {
      setNivelEducativo("VERIFICAR CÓDIGO");
    } else {
      setNivelEducativo("");
    }
  }, [codigoNivelEducativo]);

  const [codigoTipoEnf, setCodigoTipoEnf] = useState("");
  const handleCodigoTipoEnf = (event) => {
    const inputValue = event.target.value;
    clearError("codigoTipoEnf");
    if (inputValue === "") {
      setCodigoTipoEnf("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 26) {
      setCodigoTipoEnf(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 26)) {
      setCodigoTipoEnf("");
    } else {
      setCodigoTipoEnf(inputValue);
    }
  };

  useEffect(() => {
    const map = {
      1: "Adulto sano",
      2: "Algunas enfermedades infecciosas o parasitarias",
      3: "Anomalías del desarrollo prenatal",
      4: "Condiciones relacionadas con la salud sexual",
      5: "Embarazo, parto, puerperio o trastornos hormonales",
      6: "Enfermedades de la piel y anexos",
      7: "Enfermedades de la sangre o de los órganos hematopoyéticos",
      8: "Enfermedades de las glándulas mamarias",
      9: "Enfermedades degenerativas",
      10: "Enfermedades del aparato digestivo",
      11: "Enfermedades del aparato genitourinario",
      12: "Enfermedades del aparato respiratorio",
      13: "Enfermedades del ojo y sus anexos",
      14: "Enfermedades del oído o de la apófisis mastoides",
      15: "Enfermedades del sistema circulatorio o cardiovascular",
      16: "Enfermedades del sistema inmunitario",
      17: "Enfermedades del sistema musculoesquelético, de los nervios o del tejido conectivo",
      18: "Enfermedades del sistema nervioso",
      19: "Enfermedades endocrinas, nutricionales o metabólicas",
      20: "Enfermedades odontológicas",
      21: "Factores que influyen en el estado de salud o el contacto con los servicios de salud",
      22: "Neoplasias",
      23: "Niño/adolescente sano",
      24: "Trastornos mentales, del comportamiento y del neurodesarrollo",
      25: "Traumatismos, intoxicaciones u otras consecuencias de causas externas de morbilidad o mortalidad",
      26: "N/A",
    };
    if (map[codigoTipoEnf]) {
      setTipoEnfermedad(map[codigoTipoEnf]);
    } else if (codigoTipoEnf) {
      setTipoEnfermedad("VERIFICAR CÓDIGO");
    } else {
      setTipoEnfermedad("");
    }
  }, [codigoTipoEnf]);

  const [codigoTipoEnf2, setCodigoTipoEnf2] = useState("");
  const handleCodigoTipoEnf2 = (event) => {
    const inputValue = event.target.value;
    clearError("codigoTipoEnf2");
    setCodigoTipoEnf2(inputValue);
  };

  useEffect(() => {
    const map = {
      1: "Adulto sano",
      2: "Algunas enfermedades infecciosas o parasitarias",
      3: "Anomalías del desarrollo prenatal",
      4: "Condiciones relacionadas con la salud sexual",
      5: "Embarazo, parto, puerperio o trastornos hormonales",
      6: "Enfermedades de la piel y anexos",
      7: "Enfermedades de la sangre o de los órganos hematopoyéticos",
      8: "Enfermedades de las glándulas mamarias",
      9: "Enfermedades degenerativas",
      10: "Enfermedades del aparato digestivo",
      11: "Enfermedades del aparato genitourinario",
      12: "Enfermedades del aparato respiratorio",
      13: "Enfermedades del ojo y sus anexos",
      14: "Enfermedades del oído o de la apófisis mastoides",
      15: "Enfermedades del sistema circulatorio o cardiovascular",
      16: "Enfermedades del sistema inmunitario",
      17: "Enfermedades del sistema musculoesquelético, de los nervios o del tejido conectivo",
      18: "Enfermedades del sistema nervioso",
      19: "Enfermedades endocrinas, nutricionales o metabólicas",
      20: "Enfermedades odontológicas",
      21: "Factores que influyen en el estado de salud o el contacto con los servicios de salud",
      22: "Neoplasias",
      23: "Niño/adolescente sano",
      24: "Trastornos mentales, del comportamiento y del neurodesarrollo",
      25: "Traumatismos, intoxicaciones u otras consecuencias de causas externas de morbilidad o mortalidad",
      26: "N/A",
    };
    if (map[codigoTipoEnf2]) {
      setTipoEnfermedad2(map[codigoTipoEnf2]);
    } else if (codigoTipoEnf2) {
      setTipoEnfermedad2("VERIFICAR CÓDIGO");
    } else {
      setTipoEnfermedad2("");
    }
  }, [codigoTipoEnf2]);

  ///////////////////// AutoComplete States /////////////////////////
  const [inputValue, setInputValue] = React.useState("");
  const [inputValueMel, setInputValueMel] = React.useState("");
  const [medicamentos, setMedicamentos] = useState([]);
  const [patologias, setPatologias] = useState([]);
  const [tratamiento, setTratamiento] = useState([]);
  const [inputTratamiento, setInputTratamiento] = useState([]);

  const [medicoM5, setMedicoM5] = useState("");
  const [ejecutar, setEjecutar] = React.useState(true);
  var prueba = [];
  const [usuarios, setUsuarios] = useState([]);
  const [value, setValue] = React.useState(null);

  ///////////////////// Disable Button State /////////////////////////
  const [disableBtnSalud, setDisableBtnSalud] = React.useState(false);

  ////////////////////////////////////////////////////////////////////
  const oracionFormato = (string) => {
    if (typeof string !== "string") return "";
    return string
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  ////////////////////////////////////////////////////////////////////

  const getUsuarios = async () => {
    try {
      const { data } = await axios.get("/usuariostranscripcion");
      let datos = data;
      for (let i = 0; i < datos.length; i++) {
        datos[i].nombreCompleto = datos[i].nombres + " " + datos[i].apellidos;
      }
      setUsuarios(datos);
    } catch (error) {
      console.log("error fetching users", error);
    }
  };
  const getMedicamentos = async () => {
    try {
      const { data } = await axios.get("/medicamentos/", {
        params: {
          codigoProyecto: Number(proyect.idProyecto),
          sector: 3,
        },
      });
      setMedicamentos(data);
    } catch (error) {
      console.log(error, "error fetching meds");
    }
  };
  const getPatologias = async () => {
    try {
      const { data } = await axios.get("/patologias/");
      setPatologias(data);
    } catch (error) {
      console.log(error, "error fetching patologias");
    }
  };
  //Select States
  const [valueGenero, setValueGenero] = React.useState("");
  const handleChangeGenero = (event) => {
    clearError("valueGenero");
    setValueGenero(event.target.value);
  };

  const [valueTipoEnf, setValueTipoEnf] = React.useState("");
  const handleChangeValueTipoEnf = (event) => {
    setValueTipoEnf(event.target.value);
  };

  const [rangoEdadBenef, setRangoEdadBenef] = React.useState("");
  const handleChangeRangoEdad = (event) => {
    setRangoEdadBenef(event.target.value);
  };

  const handleChangeDisc = (event) => {
    clearError("codigoDisc");
    setDisc(event.target.value);
  };

  const [sexoBenef, setSexoBenef] = React.useState("");
  const handleSexoBenef = (event) => {
    clearError("sexoBenef");
    setSexoBenef(event.target.value);
  };

  const [lgbtqi, setLgbtqi] = React.useState("");
  const handleLgbtqi = (event) => {
    clearError("lgbtqi");
    setLgbtqi(event.target.value);
  };

  const handleGrupoEtnico = (event) => {
    setGrupoEtnico(event.target.value);
  };

  const handleCondicionMovilidad = (event) => {
    setCondicionMovilidad(event.target.value);
  };

  const handleFactoresRiesgo = (event) => {
    setFactoresRiesgo(event.target.value);
  };

  const handleFactoresRiesgo2 = (event) => {
    setFactoresRiesgo2(event.target.value);
  };

  const handleFactoresRiesgo3 = (event) => {
    setFactoresRiesgo3(event.target.value);
  };

  const handleNivelEducativo = (event) => {
    setNivelEducativo(event.target.value);
  };

  const [cabezaFamilia, setCabezaFamilia] = React.useState("");
  const handleCabezaFamilia = (event) => {
    clearError("cabezaFamilia");
    setCabezaFamilia(event.target.value);
  };

  const [ingresosPropios, setIngresosPropios] = React.useState("");
  const handleIngresosPropios = (event) => {
    clearError("ingresosPropios");
    setIngresosPropios(event.target.value);
  };

  ///////////////// CALCULO DE EDAD ///////////////////
  useEffect(() => {
    if (fechaNacSalud) {
      const currentDate = new Date(fechaActSalud);
      const birthDate = new Date(fechaNacSalud);

      if (!isNaN(birthDate.getTime())) {
        const diffTime = currentDate - birthDate;
        const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const years = Math.floor(totalDays / 365.25);

        setEdadSalud(
          `${years} año(s) y ${Math.floor(
            (totalDays % 365.25) / 30.4375
          )} mes(es)`
        );

        // Condición principal: Verificamos si la actividad es del tipo 3
        if (tipoActividad === 3) {
          // Nueva lógica de rangos para Telemedicina + Jornada Médica
          if (years >= 0 && years <= 11) {
            setRangoEdadSalud("0-11 años");
          } else if (years >= 12 && years <= 17) {
            setRangoEdadSalud("12-17 años");
          } else if (years >= 18 && years <= 35) {
            setRangoEdadSalud("18-35 años");
          } else if (years >= 36 && years <= 54) {
            setRangoEdadSalud("36-54 años");
          } else {
            // years >= 55
            setRangoEdadSalud("Mayor de 55 años");
          }
          setValueRep("N/A");
            setValueApellidoRep("N/A");
            clearError("valueRep");
            clearError("valueApellidoRep");
        } else {
          // Lógica original para cualquier otro tipo de actividad
          if (years <= 4) {
            setRangoEdadSalud("0-4 años");
          } else if (years <= 17) {
            setRangoEdadSalud("5-17 años");
          } else {
            if (years <= 49) {
              setRangoEdadSalud("18-49 años");
            } else {
              setRangoEdadSalud("50 años o más");
            }
            setValueRep("N/A");
            setValueApellidoRep("N/A");
            clearError("valueRep");
            clearError("valueApellidoRep");
          }
        }
      } else {
        setEdadSalud("");
        setRangoEdadSalud("");
      }
    } else {
      setEdadSalud("");
      setRangoEdadSalud("");
      setValueRep("");
      setValueApellidoRep("");
    }
  }, [fechaNacSalud, fechaActSalud, tipoActividad]);
  ///////////////////////////////////////////////

  //Alerts Handlers
  const [openAlert, setOpenAlert] = React.useState(false);
  const [openNotiError, setOpenNotiError] = React.useState(false);

  const validateForm = () => {
    const newErrors = {};
    const years = fechaNacSalud
      ? Math.floor(
          (new Date(fechaActSalud) - new Date(fechaNacSalud)) /
            (1000 * 60 * 60 * 24 * 365.25)
        )
      : -1;
    // Datos del Beneficiario
    if (!codigoBeneficiario.trim())
      newErrors.codigoBeneficiario = "Este campo es requerido";
    if (!valueNombre.trim()) newErrors.valueNombre = "Este campo es requerido";
    if (!valueApellido.trim())
      newErrors.valueApellido = "Este campo es requerido";
    if (!sexoBenef) newErrors.sexoBenef = "Este campo es requerido";
    if (!valueGenero) newErrors.valueGenero = "Este campo es requerido";
    if (!fechaNacSalud) newErrors.fechaNacSalud = "Este campo es requerido";

    // Datos del Representante
    if (!valueRep.trim()) newErrors.valueRep = "Requerido para menores de edad";
    if (!valueApellidoRep.trim())
      newErrors.valueApellidoRep = "Requerido para menores de edad";

    // Datos Demográficos
    if (!lgbtqi) newErrors.lgbtqi = "Este campo es requerido";
    if (!comunidadSalud.trim())
      newErrors.comunidadSalud = "Este campo es requerido";
    if (!codigoGrupoEtnico || grupoEtnico === "VERIFICAR CÓDIGO")
      newErrors.codigoGrupoEtnico = "Código inválido o requerido";
    if (!codigoDisc || valueDisc === "VERIFICAR CÓDIGO")
      newErrors.codigoDisc = "Código inválido o requerido";
    if (!codigoMovilidad || condicionMovilidad === "VERIFICAR CÓDIGO")
      newErrors.codigoMovilidad = "Código inválido o requerido";
    if (!codigoFactoresRiesgo || factoresRiesgo === "VERIFICAR CÓDIGO")
      newErrors.codigoFactoresRiesgo = "Código inválido o requerido";
    if (!codigoFactoresRiesgo2 || factoresRiesgo2 === "VERIFICAR CÓDIGO")
      newErrors.codigoFactoresRiesgo2 = "Código inválido o requerido";
    if (!codigoFactoresRiesgo3 || factoresRiesgo3 === "VERIFICAR CÓDIGO")
      newErrors.codigoFactoresRiesgo3 = "Código inválido o requerido";
    if (!codigoNivelEducativo || nivelEducativo === "VERIFICAR CÓDIGO")
      newErrors.codigoNivelEducativo = "Código inválido o requerido";
    if (!cabezaFamilia) newErrors.cabezaFamilia = "Este campo es requerido";
    if (!ingresosPropios) newErrors.ingresosPropios = "Este campo es requerido";

    // Datos de Consulta y Manejo
    /*if (years >= 0 && years < 18 && !peso.trim())
      newErrors.peso = "Requerido para menores de edad";*/
    if (data.some((item) => !item.motivoConsulta.trim()))
      newErrors.motivoConsulta = "Debe rellenar todos los motivos.";
    if (data3.some((item) => !item.diagnostico.trim()))
      newErrors.diagnostico = "Debe rellenar todos los diagnósticos.";
    if (!codigoTipoEnf || tipoEnfermedad === "VERIFICAR CÓDIGO")
      newErrors.codigoTipoEnf = "Código inválido o requerido";
    if (!codigoTipoEnf2 || tipoEnfermedad2 === "VERIFICAR CÓDIGO")
      newErrors.codigoTipoEnf2 = "Código inválido o requerido";
    if (tratamiento.length === 0)
      newErrors.tratamiento = "Debe seleccionar al menos un tratamiento.";

    // Adicionales
    if (!inputValue.trim() || !medicoM5)
      newErrors.medico = "Debe seleccionar un médico responsable.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      setOpenNotiError(true);
      setTimeout(() => setOpenNotiError(false), 3000);
      return;
    }

    setDisableBtnSalud(true);

    const motivosConsulta = data.map((item) => item.motivoConsulta);
    const diagnosticosConsulta = data3.map((item) => item.diagnostico);

    const resultados = tratamiento.map((medicamentoBuscar) => {
      const encontrado = medicamentos.find(
        (m) => m.descripcion === medicamentoBuscar
      );
      return {
        descripcion: medicamentoBuscar,
        id_medicamento: encontrado ? encontrado.id_medicamento : null,
      };
    });

    const cedu = valueCedula.trim() === "" ? "N/P" : valueCedula;
    const telef =
      !tlf.textmask ||
      tlf.textmask.trim() === "" ||
      tlf.textmask.trim() === "+" ||
      tlf.textmask === "+00(__) 000-0000"
        ? "N/P"
        : tlf.textmask;

    try {
      await axios
        .post("/crearBeneficiarioSalud", {
          codigo_proyecto: Number(proyect.idProyecto),
          id_convocatoria: proyect.id,
          estado: estadoSalud,
          municipio: municipioSalud,
          parroquia: parroquiaSalud,
          centro: estSalud,
          comunidad: comunidadSalud,
          grupo_etnico: codigoGrupoEtnico,
          cedula: cedu,
          nombre_rep: valueRep,
          apellido_rep: valueApellidoRep,
          telefono: telef,
          codigo: codigoBeneficiario,
          nombre: valueNombre,
          apellido: valueApellido,
          sexo: sexoBenef,
          genero: valueGenero,
          lgbtqi: lgbtqi,
          nivel_educativo: codigoNivelEducativo,
          rango_edad: rangoEdadSalud,
          ingresos: ingresosPropios,
          movilidad: codigoMovilidad,
          factores_riesgo1: codigoFactoresRiesgo,
          factores_riesgo2: codigoFactoresRiesgo2,
          factores_riesgo3: codigoFactoresRiesgo3,
          cabeza_familia: cabezaFamilia,
          motivoConsulta1: motivosConsulta[0] || null,
          motivoConsulta2: motivosConsulta[1] || null,
          motivoConsulta3: motivosConsulta[2] || null,
          motivoConsulta4: motivosConsulta[3] || null,
          motivoConsulta5: motivosConsulta[4] || null,
          tratamientos: JSON.stringify(tratamiento),
          diagnosticos1: diagnosticosConsulta[0] || null,
          diagnosticos2: diagnosticosConsulta[1] || null,
          diagnosticos3: diagnosticosConsulta[2] || null,
          diagnosticos4: diagnosticosConsulta[3] || null,
          diagnosticos5: diagnosticosConsulta[4] || null,
          tipo_enfermedad1: codigoTipoEnf,
          tipo_enfermedad2: codigoTipoEnf2,
          fecha_nacimiento: fechaNacSalud,
          fecha_evaluacion: fechaActSalud,
          edad: edadSalud,
          discapacidad: codigoDisc,
          peso: peso,
          comentarios: comentAdicionales,
          medico: inputValue,
          medicoId: medicoM5,
          estatus: 0,
          tipo: "Salud",
          clasificacion:clasificacion,
          transcrito: items.usuario,
          resultado: resultados,
        })
        .then(function (response) {
          setOpenAlert(true);
          setTimeout(() => setOpenAlert(false), 2000);

          // Reset form fields
          setValueNombre("");
          setValueApellido("");
          setSexoBenef("");
          setValueGenero("");
          setValueCedula("");
          setValueTlf({ textmask: "" });
          setFechaNacSalud(null);
          setEdadSalud("");
          setValueRep("");
          setValueApellidoRep("");
          setLgbtqi("");
          setCodigoGrupoEtnico("");
          setGrupoEtnico("");
          setCodigoDisc("");
          setDisc("");
          setCodigoMovilidad("");
          setCondicionMovilidad("");
          setCodigoFactoresRiesgo("");
          setFactoresRiesgo("");
          setCodigoFactoresRiesgo2("");
          setFactoresRiesgo2("");
          setCodigoFactoresRiesgo3("");
          setFactoresRiesgo3("");
          setCodigoNivelEducativo("");
          setNivelEducativo("");
          setCabezaFamilia("");
          setIngresosPropios("");
          setPeso("");
          setData([{ motivoConsulta: "" }]);
          setData3([{ diagnostico: "" }]);
          setCodigoTipoEnf("");
          setTipoEnfermedad("");
          setCodigoTipoEnf2("");
          setTipoEnfermedad2("");
          setTratamiento([]);
          setValueCA("");
          setErrors({});
          setInputValue("");
          setMedicoM5("");
          setValue(null);
          setCodigoBeneficiario("");
          setComunidadSalud("");
        })
        .catch(function (error) {
          setOpenNotiError(true);
          setTimeout(() => setOpenNotiError(false), 3000);
        })
        .finally(() => {
          setDisableBtnSalud(false);
        });
    } catch (error) {
      console.error("Error en submit:", error);
      setDisableBtnSalud(false);
    }
  };

  const [estados, setEstados] = React.useState([]);
  const [municipios, setMunicipios] = React.useState([]);
  const [parroquias, setParroquias] = React.useState([]);

  const getEstados = async () => {
    try {
      const { data } = await axios.get("/getEstados/");
      let datos1 = data.find(({ idestado }) => idestado == proyect.estadoConvo);
      if (datos1) setEstadoSalud(datos1.nombre);
    } catch (error) {
      console.log("error fetching estados", error);
    }
  };
  const getMunicipios = async () => {
    try {
      const { data } = await axios.get("/getMunicipios/", {
        params: { id: proyect.estadoConvo },
      });
      let datos1 = data.find(
        ({ idmunicipios }) => idmunicipios == proyect.municipio
      );
      if (datos1) setMunicipioSalud(datos1.nombre);
      setMunicipios(data);
    } catch (error) {
      console.log("error fetching municipios", error);
    }
  };
  const getParroquias = async () => {
    try {
      const { data } = await axios.get("/getParroquias/", {
        params: { id: proyect.municipio },
      });
      let datos1 = data.find(
        ({ idparroquias }) => idparroquias == proyect.parroquia
      );
      if (datos1) setParroquiaSalud(datos1.nombre);
      setParroquias(data);
    } catch (error) {
      console.log("error fetching parroquias", error);
    }
  };

  useEffect(() => {
    if (ejecutar) {
      getUsuarios();
      getPatologias();
      getMedicamentos();
      getEstados();
      getMunicipios();
      getParroquias();
      setEjecutar(false);
    }
  }, [ejecutar]);

  return (
    <Box m="1.5rem 2.5rem">
      {rol === "1" ||
      rol === "2" ||
      rol === "6" ||
      rol === "8" ||
      rol === "9" ||
      rol === "10" ||
      rol === "11" ? (
        <>
          <Collapse in={openAlert}>
            <Alert
              variant="filled"
              severity="success"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenAlert(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡Datos guardados exitosamente!
            </Alert>
          </Collapse>
          <Collapse in={openNotiError}>
            <Alert
              variant="filled"
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenNotiError(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡Error al guardar! Verifique los campos requeridos.
            </Alert>
          </Collapse>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            p="1.25rem 1rem"
            flex="1 1 100%"
            borderRadius="0.55rem"
          >
            <CssBaseline />
            <Box
              role="presentation"
              onClick={handleClickBreadCrumbs}
              sx={{ mb: 3 }}
            >
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/inicio"
                  onClick={(event) => handleLinkHome(event, "home")}
                >
                  <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Inicio
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/listaTranscripcion"
                  onClick={(event) =>
                    handleLinkTranscripcion(event, "transcripcion")
                  }
                >
                  <DriveFileRenameOutlineIcon
                    sx={{ mr: 0.5 }}
                    fontSize="inherit"
                  />
                  Transcripción
                </Link>
                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  <NoteAddOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  {tipoActividad === 3
                    ? "Nuevo Beneficiario (Salud/Telemedicina)"
                    : "Nuevo Beneficiario (Salud)"}
                </Typography>
              </Breadcrumbs>
              <Typography
                variant="h3"
                component="div"
                sx={{ mt: 3, mb: 1, fontWeight: "bold" }}
              >
                {tipoActividad === 3
                  ? "Nuevo Beneficiario (Salud/Telemedicina)"
                  : "Nuevo Beneficiario (Salud)"}
              </Typography>
            </Box>
            <Container>
              <Card
                sx={{
                  borderRadius: 8,
                  boxShadow: 5,
                  bgcolor: theme.palette.background.alt,
                }}
              >
                <CardContent>
                  <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                    sx={{ mt: 3 }}
                  >
                    <Box>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="INFO. GENERAL" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Estado"
                            value={estadoSalud}
                            disabled
                            onChange={(event) =>
                              setEstadoSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Municipio"
                            value={municipioSalud}
                            disabled
                            onChange={(event) =>
                              setMunicipioSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Parroquia"
                            value={parroquiaSalud}
                            disabled
                            onChange={(event) =>
                              setParroquiaSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Establecimiento de Salud"
                            value={estSalud}
                            disabled
                            onChange={(event) =>
                              setEstSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha de Atención"
                              name="fechaActividad"
                              inputFormat="DD/MM/YYYY"
                              value={fechaActSalud}
                              onChange={setFechaActSalud}
                              disabled
                              renderInput={(params) => {
                                return <TextField fullWidth {...params} />;
                              }}
                              clearable
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="DATOS DEL BENEFICIARIO" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Codigo"
                            fullWidth
                            required
                            value={codigoBeneficiario}
                            onChange={(event) => {
                              setCodigoBeneficiario(
                                oracionFormato(event.target.value)
                              );
                              clearError("codigoBeneficiario");
                            }}
                            error={!!errors.codigoBeneficiario}
                            helperText={errors.codigoBeneficiario}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Primer Nombre"
                            fullWidth
                            required
                            value={valueNombre}
                            onChange={(event) => {
                              setValueNombre(
                                oracionFormato(event.target.value)
                              );
                              clearError("valueNombre");
                            }}
                            error={!!errors.valueNombre}
                            helperText={errors.valueNombre}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Primer Apellido"
                            fullWidth
                            required
                            value={valueApellido}
                            onChange={(event) => {
                              setValueApellido(
                                oracionFormato(event.target.value)
                              );
                              clearError("valueApellido");
                            }}
                            error={!!errors.valueApellido}
                            helperText={errors.valueApellido}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.sexoBenef}>
                            <InputLabel id="sexo">Sexo</InputLabel>
                            <Select
                              value={sexoBenef}
                              label="Sexo"
                              onChange={handleSexoBenef}
                            >
                              <MenuItem value={"Mujer"}>Mujer</MenuItem>
                              <MenuItem value={"Hombre"}>Hombre</MenuItem>
                            </Select>
                            {errors.sexoBenef && (
                              <FormHelperText>
                                {errors.sexoBenef}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.valueGenero}>
                            <InputLabel id="genero">Género</InputLabel>
                            <Select
                              value={valueGenero}
                              label="Género"
                              onChange={handleChangeGenero}
                            >
                              <MenuItem value={"Femenino"}>Femenino</MenuItem>
                              <MenuItem value={"Masculino"}>Masculino</MenuItem>
                              <MenuItem value={"Otro"}>Otro</MenuItem>
                            </Select>
                            {errors.valueGenero && (
                              <FormHelperText>
                                {errors.valueGenero}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="cedula"
                            fullWidth
                            id="cedula"
                            label="Cédula de Identidad"
                            value={valueCedula}
                            onChange={(event) =>
                              setValueCedula(
                                event.target.value
                                  .replace(/[^\d]/g, "")
                                  .slice(0, 10)
                              )
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="telefono" variant="outlined">
                              Teléfono
                            </InputLabel>
                            <OutlinedInput
                              value={tlf.textmask}
                              onChange={handleTlf}
                              name="textmask"
                              id="telefono"
                              inputComponent={TextMaskCustom}
                              label="Teléfono"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha de Nacimiento"
                              name="fechaNacimiento"
                              inputFormat="DD/MM/YYYY"
                              value={fechaNacSalud}
                              onChange={(newValue) => {
                                setFechaNacSalud(newValue);
                                clearError("fechaNacSalud");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  error={!!errors.fechaNacSalud}
                                  helperText={errors.fechaNacSalud}
                                />
                              )}
                              clearable
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={tipoActividad === 3 ? 2 : 4}>
                          <TextField
                            label="Edad"
                            fullWidth
                            required
                            disabled
                            value={edadSalud}
                            onChange={(event) =>
                              setEdadSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={2} hidden={tipoActividad !== 3}>
                          <TextField
                            label="Grupo Etario"
                            fullWidth
                            required
                            disabled
                            value={rangoEdadSalud}
                            onChange={(event) =>
                              setRangoEdadSalud(event.target.value)
                            }
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="DATOS DEL REPRESENTANTE" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            name="representante"
                            fullWidth
                            id="representante"
                            label="Primer Nombre"
                            disabled={
                              rangoEdadSalud === "18-49 años" ||
                              rangoEdadSalud === "50 años o más" ||
                              rangoEdadSalud === "18-35 años" ||
                              rangoEdadSalud === "36-54 años" ||
                              rangoEdadSalud === "Mayor de 55 años" ||
                              rangoEdadSalud === ""
                            }
                            value={valueRep}
                            onChange={(event) => {
                              setValueRep(oracionFormato(event.target.value));
                              clearError("valueRep");
                            }}
                            error={!!errors.valueRep}
                            helperText={errors.valueRep}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Primer Apellido"
                            value={valueApellidoRep}
                            disabled={
                              rangoEdadSalud === "18-49 años" ||
                              rangoEdadSalud === "50 años o más" ||
                              rangoEdadSalud === "18-35 años" ||
                              rangoEdadSalud === "36-54 años" ||
                              rangoEdadSalud === "Mayor de 55 años" ||
                              rangoEdadSalud === ""
                            }
                            onChange={(event) => {
                              setValueApellidoRep(
                                oracionFormato(event.target.value)
                              );
                              clearError("valueApellidoRep");
                            }}
                            error={!!errors.valueApellidoRep}
                            helperText={errors.valueApellidoRep}
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip
                          label="DATOS DEMOGRÁFICOS DEL BENEFICIARIO"
                          sx={{
                            "&.MuiChip-root": {
                              fontSize: isSmallScreen ? "9px" : "auto",
                            },
                          }}
                        />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.lgbtqi}>
                            <InputLabel id="lgbtqi">LGBTQI+</InputLabel>
                            <Select
                              value={lgbtqi}
                              label="LGBTQI+"
                              onChange={handleLgbtqi}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.lgbtqi && (
                              <FormHelperText>{errors.lgbtqi}</FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Comunidad"
                            value={comunidadSalud}
                            onChange={(event) => {
                              setComunidadSalud(
                                oracionFormato(event.target.value)
                              );
                              clearError("comunidadSalud");
                            }}
                            error={!!errors.comunidadSalud}
                            helperText={errors.comunidadSalud}
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            error={!!errors.codigoGrupoEtnico}
                            label="Código"
                            type="number"
                            value={codigoGrupoEtnico}
                            onChange={handleCodigoGrupoEtnico}
                            helperText={errors.codigoGrupoEtnico}
                            inputProps={{ min: 1, max: 7, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={grupoEtnico === "VERIFICAR CÓDIGO"}
                            label="Grupo Etnico"
                            value={grupoEtnico}
                            disabled
                            onChange={(event) =>
                              setGrupoEtnico(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoDisc}
                            label="Código"
                            value={codigoDisc}
                            onChange={handleCodigoDisc}
                            helperText={errors.codigoDisc}
                            inputProps={{ min: 1, max: 5, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={valueDisc === "VERIFICAR CÓDIGO"}
                            label="Discapacidad"
                            value={valueDisc}
                            disabled
                            onChange={(event) => setDisc(event.target.value)}
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoMovilidad}
                            label="Código"
                            value={codigoMovilidad}
                            onChange={handleCodigoMovilidad}
                            helperText={errors.codigoMovilidad}
                            inputProps={{ min: 1, max: 5, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={condicionMovilidad === "VERIFICAR CÓDIGO"}
                            label="Condición de Movilidad"
                            value={condicionMovilidad}
                            disabled
                            onChange={(event) =>
                              setCondicionMovilidad(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo}
                            label="Código"
                            value={codigoFactoresRiesgo}
                            onChange={handleCodigoFactoresRiesgo}
                            helperText={errors.codigoFactoresRiesgo}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 1"
                            value={factoresRiesgo}
                            disabled
                            onChange={(event) =>
                              setFactoresRiesgo(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo2}
                            label="Código"
                            value={codigoFactoresRiesgo2}
                            onChange={handleCodigoFactoresRiesgo2}
                            helperText={errors.codigoFactoresRiesgo2}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo2 === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 2"
                            value={factoresRiesgo2}
                            disabled
                            onChange={(event) =>
                              setFactoresRiesgo2(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo3}
                            label="Código"
                            value={codigoFactoresRiesgo3}
                            onChange={handleCodigoFactoresRiesgo3}
                            helperText={errors.codigoFactoresRiesgo3}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo3 === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 3"
                            value={factoresRiesgo3}
                            disabled
                            onChange={(event) =>
                              setFactoresRiesgo3(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoNivelEducativo}
                            label="Código"
                            value={codigoNivelEducativo}
                            onChange={handleCodigoNivelEducativo}
                            helperText={errors.codigoNivelEducativo}
                            inputProps={{ min: 1, max: 6, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={nivelEducativo === "VERIFICAR CÓDIGO"}
                            label="Nivel Educativo"
                            value={nivelEducativo}
                            disabled
                            onChange={(event) =>
                              setNivelEducativo(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.cabezaFamilia}>
                            <InputLabel id="cabezaFamilia">
                              Cabeza de Familia
                            </InputLabel>
                            <Select
                              value={cabezaFamilia}
                              label="Cabeza de Familia"
                              onChange={handleCabezaFamilia}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.cabezaFamilia && (
                              <FormHelperText>
                                {errors.cabezaFamilia}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            error={!!errors.ingresosPropios}
                          >
                            <InputLabel id="ingresosPropios">
                              Ingresos Propios
                            </InputLabel>
                            <Select
                              value={ingresosPropios}
                              label="Ingresos Propios"
                              onChange={handleIngresosPropios}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.ingresosPropios && (
                              <FormHelperText>
                                {errors.ingresosPropios}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 2 }}>
                        <Chip label="DATOS DE CONSULTA Y MANEJO" />
                      </Divider>
                      <Grid
                        container
                        spacing={1}
                        hidden={
                          rangoEdadSalud === "18-49 años" ||
                          rangoEdadSalud === "50 años o más" ||
                          rangoEdadSalud === "18-35 años" ||
                          rangoEdadSalud === "36-54 años" ||
                          rangoEdadSalud === "Mayor de 55 años" ||
                          rangoEdadSalud === ""
                        }
                      >
                        <Grid
                          item
                          xs={12}
                          sm={5}
                          ml={2}
                          mb={!isSmallScreen ? 1 : 0}
                        >
                          <TextField
                            type="number"
                            label="Peso (Kg)"
                            value={peso}
                            onChange={(event) => {
                              setPeso(event.target.value);
                              //clearError("peso");
                            }}
                            sx={{ width: isSmallScreen ? "100%" : "94%" }}
                            //error={!!errors.peso}
                            //helperText={errors.peso}
                          />
                        </Grid>
                      </Grid>
                      <div style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isSmallScreen ? "column" : "row",
                          }}
                        >
                          <Item sx={{ width: "100%" }}>
                            {data.map((val, i) => (
                              <div key={i}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    xs={
                                      data[0].motivoConsulta === "" ||
                                      data.length === 1
                                        ? 12
                                        : 9
                                    }
                                    sm={10}
                                    mt={1}
                                  >
                                    <TextField
                                      fullWidth
                                      id="motivoConsulta"
                                      label="Motivo de Consulta"
                                      name="motivoConsulta"
                                      value={val.motivoConsulta}
                                      onChange={(e) => handleChangeInput(e, i)}
                                      onKeyDown={(e) =>
                                        e.code === "Enter" && data.length < 5
                                          ? handleClick(e, i)
                                          : null
                                      }
                                      error={
                                        !!errors.motivoConsulta &&
                                        !val.motivoConsulta.trim()
                                      }
                                      helperText={
                                        !!errors.motivoConsulta &&
                                        !val.motivoConsulta.trim()
                                          ? "No puede estar vacío"
                                          : ""
                                      }
                                    />
                                  </Grid>
                                  <Grid item xs={2} sm={1}>
                                    <Tooltip title="Eliminar">
                                      <IconButton
                                        aria-label="delete"
                                        size="large"
                                        color="error"
                                        hidden={
                                          data[0].motivoConsulta === "" ||
                                          data.length === 1
                                        }
                                        onClick={() => handleDelete(i)}
                                      >
                                        <DeleteIcon fontSize="inherit" />
                                      </IconButton>
                                    </Tooltip>
                                  </Grid>
                                </Grid>
                              </div>
                            ))}
                            <Grid container>
                              <Grid item xs={12} sm={3} sx={{ mt: 3 }}>
                                <Button
                                  variant="contained"
                                  disabled={activar}
                                  sx={{
                                    bgcolor: "teal",
                                    color: "white",
                                    borderRadius: 2,
                                  }}
                                  fullWidth
                                  onClick={handleClick}
                                  hidden={data.length === 5}
                                >
                                  Añadir Más
                                </Button>
                              </Grid>
                            </Grid>
                          </Item>
                          <Item sx={{ width: "100%" }}>
                            {data3.map((val3, i) => (
                              <div key={i}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    xs={
                                      data3[0].diagnostico === "" ||
                                      data3.length === 1
                                        ? 12
                                        : 9
                                    }
                                    sm={10}
                                    mt={1}
                                  >
                                    <TextField
                                      fullWidth
                                      id="diagnostico"
                                      label="Diagnóstico"
                                      name="diagnostico"
                                      value={val3.diagnostico}
                                      onChange={(e) => handleChangeInput3(e, i)}
                                      onKeyDown={(e) =>
                                        e.code === "Enter" && data3.length < 5
                                          ? handleClick3(e, i)
                                          : null
                                      }
                                      error={
                                        !!errors.diagnostico &&
                                        !val3.diagnostico.trim()
                                      }
                                      helperText={
                                        !!errors.diagnostico &&
                                        !val3.diagnostico.trim()
                                          ? "No puede estar vacío"
                                          : ""
                                      }
                                    />
                                  </Grid>
                                  <Grid item xs={2} sm={1}>
                                    <Tooltip title="Eliminar">
                                      <IconButton
                                        aria-label="delete"
                                        size="large"
                                        color="error"
                                        hidden={
                                          data3[0].diagnostico === "" ||
                                          data3.length === 1
                                        }
                                        onClick={() => handleDelete3(i)}
                                      >
                                        <DeleteIcon fontSize="inherit" />
                                      </IconButton>
                                    </Tooltip>
                                  </Grid>
                                </Grid>
                              </div>
                            ))}
                            <Grid container>
                              <Grid
                                item
                                xs={isSmallScreen ? 12 : 8}
                                sm={3}
                                sx={{ mt: 3 }}
                              >
                                <Button
                                  variant="contained"
                                  disabled={activar3}
                                  sx={{
                                    bgcolor: "teal",
                                    color: "white",
                                    borderRadius: 2,
                                  }}
                                  hidden={data3.length === 5}
                                  fullWidth
                                  onClick={handleClick3}
                                >
                                  Añadir Más
                                </Button>
                              </Grid>
                            </Grid>
                          </Item>
                        </Box>
                      </div>
                      <div style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isSmallScreen ? "column" : "row",
                          }}
                        >
                          <Item sx={{ width: "100%" }}>
                            <div>
                              <Grid container mt={2} spacing={1}>
                                <Grid item xs={3} sm={3}>
                                  <TextField
                                    required
                                    fullWidth
                                    type="number"
                                    error={!!errors.codigoTipoEnf}
                                    label="Código"
                                    value={codigoTipoEnf}
                                    onChange={handleCodigoTipoEnf}
                                    helperText={errors.codigoTipoEnf}
                                    inputProps={{ min: 1, max: 26, step: 1 }}
                                  />
                                </Grid>
                                <Grid item xs={9} sm={9}>
                                  <TextField
                                    fullWidth
                                    error={
                                      tipoEnfermedad === "VERIFICAR CÓDIGO"
                                    }
                                    label="Tipo de Enfermedad 1"
                                    value={tipoEnfermedad}
                                    disabled
                                    onChange={(event) =>
                                      setTipoEnfermedad(event.target.value)
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </div>
                            <br />
                          </Item>
                          <Item sx={{ width: "100%" }}>
                            <div>
                              <Grid container mt={2} spacing={1}>
                                <Grid item xs={3} sm={3}>
                                  <TextField
                                    required
                                    fullWidth
                                    type="number"
                                    error={!!errors.codigoTipoEnf2}
                                    label="Código"
                                    value={codigoTipoEnf2}
                                    onChange={handleCodigoTipoEnf2}
                                    helperText={errors.codigoTipoEnf2}
                                    inputProps={{ min: 1, max: 26, step: 1 }}
                                  />
                                </Grid>
                                <Grid item xs={9} sm={9}>
                                  <TextField
                                    fullWidth
                                    error={
                                      tipoEnfermedad2 === "VERIFICAR CÓDIGO"
                                    }
                                    label="Tipo de Enfermedad 2"
                                    value={tipoEnfermedad2}
                                    disabled
                                    onChange={(event) =>
                                      setTipoEnfermedad2(event.target.value)
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </div>
                            <br />
                          </Item>
                          <Item sx={{ width: "100%" }}>
                            <div>
                              <Grid
                                container
                                spacing={2}
                                sx={{ mt: !isSmallScreen ? 1 : 0 }}
                              >
                                <Grid item xs={12} sm={10}>
                                  <Autocomplete
                                    multiple
                                    fullWidth
                                    name="tratamiento"
                                    value={tratamiento}
                                    onChange={(e, newValue) => {
                                      setTratamiento(newValue);
                                      if (newValue.length > 0)
                                        clearError("tratamiento");
                                    }}
                                    inputValue={inputTratamiento}
                                    onInputChange={(e, newInputValue) => {
                                      setInputTratamiento(newInputValue);
                                    }}
                                    options={medicamentos.map(
                                      (option) => option.descripcion
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Tratamiento"
                                        fullWidth
                                        error={!!errors.tratamiento}
                                        helperText={errors.tratamiento}
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </div>
                            <br />
                          </Item>
                        </Box>
                      </div>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="ADICIONALES" />
                      </Divider>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            value={value}
                            onChange={(event, newValue) => {
                              setMedicoM5(newValue ? newValue.id : "");
                              setValue(newValue);
                              if (newValue) clearError("medico");
                            }}
                            inputValue={inputValue}
                            onInputChange={(event, newInputValue) => {
                              setInputValue(newInputValue);
                              if (newInputValue) clearError("medico");
                            }}
                            disablePortal
                            id="combo-box-demo"
                            options={usuarios}
                            getOptionLabel={(option) =>
                              option.nombreCompleto || ""
                            }
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Médico Responsable"
                                error={!!errors.medico}
                                helperText={errors.medico}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Comentarios"
                            value={comentAdicionales}
                            fullWidth
                            multiline
                            maxRows={4}
                            onChange={(event) =>
                              setValueCA(oracionFormato(event.target.value))
                            }
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 5 }}></Divider>
                      <Grid
                        container
                        sx={{ mt: 2 }}
                        spacing={1}
                        justifyContent="center"
                      >
                        <Grid item sm={3} xs={6}>
                          <Button
                            variant="contained"
                            color="error"
                            size="large"
                            fullWidth
                            onClick={handleOpen}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                        <Grid item sm={3} xs={6}>
                          <Button
                            type="submit"
                            variant="contained"
                            sx={{ bgcolor: "teal", color: "white" }}
                            size="large"
                            fullWidth
                            disabled={disableBtnSalud}
                          >
                            Guardar
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                slotProps={{ backdrop: { style: { opacity: 0.2 } } }}
              >
                <Box sx={style}>
                  <Typography
                    variant="h6"
                    className="text-center"
                    sx={{ mb: 1.5 }}
                  >
                    ¿Está seguro de cancelar esta operación?
                  </Typography>
                  <Divider sx={{ mt: 2 }} />
                  <Grid
                    container
                    sx={{ mt: 1 }}
                    spacing={1}
                    justifyContent="flex-end"
                  >
                    <Grid item>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                      >
                        No
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        sx={{ bgcolor: "teal", color: "white" }}
                        onClick={(event) =>
                          handleLinkCancelar(event, "cancelar")
                        }
                      >
                        Si
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </Container>
          </Box>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

export default SaludForm;
